import React from 'react'

export interface SparkleDividerProps {
  /** Optional extra class for layout / margin overrides. */
  className?: string
}

/**
 * Decorative horizontal divider with a small sparkle cluster in the middle,
 * used between the modal hero and the option grid in the Smart Create Playlist
 * and Vibe Line modals.
 *
 * The SVG is intentionally `width: 100%` (controlled via SCSS) so the same
 * source asset stretches between the 477px (playlist) and 620px (vibe) parent
 * widths without distortion — the viewBox keeps the sparkle centered.
 *
 * Decorative-only — `aria-hidden` is set so screen readers skip it.
 */
function SparkleDivider ({ className = '' }: SparkleDividerProps) {
  const rootClass = ['sparkle-divider', className].filter(Boolean).join(' ')
  return (
    <svg
      className={rootClass}
      width="620"
      height="19"
      viewBox="0 0 620 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="presentation"
      aria-hidden="true"
      preserveAspectRatio="xMidYMid meet"
    >
      {/* Left tapered horizontal stroke */}
      <path
        d="M294 10.5616C294 9.56155 294 8.56155 294 7.56155C289.1 7.58655 284.2 7.61155 279.3 7.63655C191.1 8.08655 102.9 8.53655 14.7 8.98655C9.79997 9.01155 4.9 9.03655 0 9.06155C4.9 9.08655 9.79997 9.11155 14.7 9.13655C102.9 9.58655 191.1 10.0366 279.3 10.4866C284.2 10.5116 289.1 10.5366 294 10.5616Z"
        fill="currentColor"
      />
      {/* Center sparkle cluster (3 stars stacked) */}
      <path
        d="M310 2.06155L310.911 5.70575C311.089 6.41685 311.178 6.7724 311.363 7.06172C311.527 7.31763 311.744 7.53496 312 7.69871C312.289 7.88384 312.645 7.97273 313.356 8.15051L317 9.06155L313.356 9.9726C312.645 10.1504 312.289 10.2393 312 10.4244C311.744 10.5881 311.527 10.8055 311.363 11.0614C311.178 11.3507 311.089 11.7063 310.911 12.4174L310 16.0616L309.089 12.4174C308.911 11.7063 308.822 11.3507 308.637 11.0614C308.473 10.8055 308.256 10.5881 308 10.4244C307.711 10.2393 307.355 10.1504 306.644 9.9726L303 9.06155L306.644 8.15051C307.355 7.97273 307.711 7.88384 308 7.69871C308.256 7.53496 308.473 7.31763 308.637 7.06172C308.822 6.7724 308.911 6.41685 309.089 5.70575L310 2.06155Z"
        fill="currentColor"
        stroke="currentColor"
        strokeMiterlimit="16"
        strokeLinecap="round"
      />
      {/* Right tapered horizontal stroke */}
      <path
        d="M326 10.5616C326 9.56155 326 8.56155 326 7.56155C330.9 7.58655 335.8 7.61155 340.7 7.63655C428.9 8.08655 517.1 8.53655 605.3 8.98655C610.2 9.01155 615.1 9.03655 620 9.06155C615.1 9.08655 610.2 9.11155 605.3 9.13655C517.1 9.58655 428.9 10.0366 340.7 10.4866C335.8 10.5116 330.9 10.5366 326 10.5616Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SparkleDivider
